import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from as observableFrom, of as observableOf } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { ClearDraftAndPublishedListsAction } from '®app/reading-lists/list/resolver-store/list-resolver-store.actions';
import { HideModalReason } from '®shared/modals';
import { ReadingListService } from '®shared/reading-list/models';

import {
  ArchiveListAction,
  ArchiveListActionTypes,
  ArchiveListFailedAction,
  ArchiveListHideModalAction,
  ArchiveListSucceededAction,
} from './archive-list.actions';

@Injectable()
export class ArchiveListEffects {
  archiveList$: Observable<
    ArchiveListSucceededAction | ArchiveListFailedAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ArchiveListActionTypes.ARCHIVE_LIST),
      switchMap((action: ArchiveListAction) => {
        const { listId } = action.payload;
        return this.readingListService.archiveList(listId).pipe(
          map(() => new ArchiveListSucceededAction(action.payload)),
          catchError(error =>
            observableOf(
              new ArchiveListFailedAction({
                ...action.payload,
                error,
              }),
            ),
          ),
        );
      }),
    ),
  );

  archiveListSuccess$: Observable<
    ClearDraftAndPublishedListsAction | ArchiveListHideModalAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ArchiveListActionTypes.ARCHIVE_LIST_SUCCEEDED),
      mergeMap((action: ArchiveListSucceededAction) => {
        const { listId } = action.payload;
        return observableFrom([
          new ClearDraftAndPublishedListsAction({ listId }),
          new ArchiveListHideModalAction({
            listId,
            reason: HideModalReason.COMPLETED,
          }),
        ]);
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private readingListService: ReadingListService,
  ) {}
}
